export default __webpack_public_path__ + "static/media/DM.9c44ca8c.svg";